const serverConfig = {
  // baseURL: "http://192.168.1.7:3030" // 请求基础地址,可根据环境自定义
  // baseURL: "http://192.168.1.10:3005/codemarket" // 请求基础地址,可根据环境自定义
  baseURL: process.env.REACT_APP_FRONT_API_URL, // 请求基础地址,可根据环境自定义
  useTokenAuthorization: true // 是否开启 token 认证
  // http://127.0.0.1:3030/upchain/storage
};
export default serverConfig;
